"use client";

import type { ReactNode } from "react";
import CmsLink from "@/components/CmsLink";

type NavLinkProps = {
  href: string;
  target?: "_self" | "_blank";
  className?: string;
  role?: string;
  children: ReactNode;
};

/** Header/nav CMS links — delegates to CmsLink (country + hash scroll). */
export const NavLink = ({ href, target, className, role, children }: NavLinkProps) => (
  <CmsLink href={href} target={target} className={className} role={role}>
    {children}
  </CmsLink>
);

export const NavChevron = () => (
  <svg className="nav-chevron" viewBox="0 0 12 12" aria-hidden="true">
    <path
      d="M2.5 4.5 6 8l3.5-3.5"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);
